// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__discountList__root","item":"cmp-Minicart__discountList__item","price":"cmp-Minicart__discountList__price"};